import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NoResultsIcon from 'react-icons/lib/md/error';
import FoundResultsIcon from 'react-icons/lib/md/check-circle';

import './resultsHeader.less';

class ResultsHeader extends Component {
    fetchIcon() {
        const iconSize = 42;

        if (this.props.resultData && this.props.resultData.length > 0) {
            return <FoundResultsIcon size={iconSize} className="success-icon" />
        }
        else {
            return <NoResultsIcon size={iconSize} className="no-results-icon" />
        }
    }

    render() {
        return (
            <div>
                <div className="results-header-text">{this.props.headerText}</div>
                <div className="results-summary">
                    <div>
                        {this.fetchIcon()}
                    </div>
                    <div className="summary-text">
                        {this.props.headerSummary}
                    </div>
                </div>
				{this.props.children}
            </div>
        );
    }

}

ResultsHeader.propTypes = {
	children: PropTypes.node,
	headerSummary: PropTypes.string.isRequired,
	headerText: PropTypes.string.isRequired,
	resultData: PropTypes.array,
};

export default ResultsHeader;



// WEBPACK FOOTER //
// ./src/react/views/generic/ResultsHeader.jsx